export default function observeStickyElement() {
	const el = document.querySelector(".sticky");
	if (el) {
		const observer = new IntersectionObserver(
			([e]) => e.target.classList.toggle("is-stuck", e.intersectionRatio < 1),
			{ threshold: [1] }
		);

		observer.observe(el);
	}
}
